{
    "Profile_SupernovaCommercial_Insureds_Insured.additionalInsuredDetails": "FR: Additional Insured details",
    "Profile_SupernovaCommercial_Insureds_Insured.businessName": "FR: Business Name",
    "Profile_SupernovaCommercial_Insureds_Insured.reasonRequired": "FR: Reason they are required to be added as an additional insured",
    "Profile_SupernovaCommercial_Insureds_Insured.addressDetails": "FR: Address Details",
    "Profile_SupernovaCommercial_Insureds_Insured.locationDetails": "FR: Location Details"
}
